import React from 'react';
import { NavLink } from 'react-router-dom';
import { BellIcon, FileTextIcon, HomeIcon, MessageSquareIcon } from 'lucide-react';
import { PortalHeader } from '../shell/PortalHeader';
import { ComplianceFooter } from '../shell/ComplianceFooter';
import { usePortal } from '../../contexts/PortalContext';
interface LoanShellProps {
  children: React.ReactNode;
}
export function LoanShell({
  children
}: LoanShellProps) {
  const {
    tasks,
    documents,
    answers
  } = usePortal();
  const openTasks = tasks.filter(t => !t.done).length;
  const openDocs = documents.filter(d => d.status === 'needed' || d.status === 'attention').length;
  const items = [{
    to: '/loan',
    label: 'Overview',
    icon: HomeIcon,
    badge: openTasks,
    end: true
  }, {
    to: '/documents',
    label: 'Documents',
    icon: FileTextIcon,
    badge: openDocs
  }, {
    to: '/loan/messages',
    label: 'Messages',
    icon: MessageSquareIcon,
    badge: 0
  }, {
    to: '/loan/updates',
    label: 'Updates',
    icon: BellIcon,
    badge: 0
  }];
  return <div className="min-h-screen w-full bg-canvas pb-24 md:pb-0" data-id="element-463" data-mp="2u0ruwswvw6nz">
      <PortalHeader center={<nav aria-label="Loan" className="hidden items-center gap-1 rounded-full bg-ink-100 p-1 md:flex" data-id="element-465" data-mp="2pyezoyfrjr5g">
            {items.map(it => <NavLink key={it.to} to={it.to} end={it.end} className={({
        isActive
      }) => `flex h-9 items-center gap-2 rounded-full px-4 text-sm font-medium transition-[background-color,color,box-shadow] duration-150 ${isActive ? 'bg-white text-ink-900 shadow-soft' : 'text-ink-500 hover:text-ink-900'}`} data-id="element-466" data-mp="2kztwcq57srcs">
                {it.label}
                {it.badge > 0 && <span className="tabular grid h-5 min-w-5 place-items-center rounded-full bg-pulse-600 px-1.5 text-[11px] text-white" data-id="element-467" data-mp="2yx8tyi5mg5fu">{it.badge}</span>}
              </NavLink>)}
          </nav>} right={<span className="grid h-9 w-9 place-items-center rounded-full bg-pulse-100 text-sm font-semibold text-pulse-800" aria-label={`${answers.firstName} ${answers.lastName}`} data-id="element-468" data-mp="1pqqeerjf9q9a">
            {answers.firstName[0]}
            {answers.lastName[0]}
          </span>} data-id="element-464" data-mp="2txx9oz61qhti" />
      {children}
      <ComplianceFooter data-id="element-469" data-mp="1kzi3fr2g1wu0" />
      <nav aria-label="Loan" className="fixed inset-x-0 bottom-0 z-30 grid grid-cols-4 border-t border-ink-200 bg-white/95 pb-5 pt-2 backdrop-blur md:hidden" data-id="element-470" data-mp="1kyyomj83bok7">
        {items.map(it => <NavLink key={it.to} to={it.to} end={it.end} className={({
        isActive
      }) => `relative flex flex-col items-center gap-1 py-1 text-[11px] font-medium transition-colors duration-150 ${isActive ? 'text-pulse-700' : 'text-ink-400'}`} data-id="element-471" data-mp="1b1u9328r2rcd">
            <span className="relative" data-id="element-472" data-mp="2rfkeccblvlnl">
              <it.icon className="h-5 w-5" aria-hidden data-id="element-473" data-mp="2rglpegsmg85b" />
              {it.badge > 0 && <span className="tabular absolute -right-2.5 -top-1.5 grid h-4 min-w-4 place-items-center rounded-full bg-pulse-600 px-1 text-[10px] text-white" data-id="element-474" data-mp="2wdvoko5tby6c">{it.badge}</span>}
            </span>
            {it.label}
          </NavLink>)}
      </nav>
    </div>;
}